import { render, staticRenderFns } from "./samsung-brand.vue?vue&type=template&id=7b17d574"
import script from "./samsung-brand.vue?vue&type=script&lang=js"
export * from "./samsung-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports